import { render, staticRenderFns } from "./UnitMenuBar.vue?vue&type=template&id=0b0fa2a8&scoped=true&"
import script from "./UnitMenuBar.vue?vue&type=script&lang=js&"
export * from "./UnitMenuBar.vue?vue&type=script&lang=js&"
import style0 from "./UnitMenuBar.vue?vue&type=style&index=0&id=0b0fa2a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0fa2a8",
  null
  
)

component.options.__file = "UnitMenuBar.vue"
export default component.exports